import React, { forwardRef } from 'react';
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: {
    value: string;
    label: string;
  }[];
}
export const Select = forwardRef<HTMLSelectElement, SelectProps>(({
  label,
  error,
  options,
  className = '',
  ...props
}, ref) => {
  return <div className="w-full" data-id="element-218">
        {label && <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-219">
            {label}
          </label>}
        <select ref={ref} className={`
            w-full rounded-lg border bg-white px-3 py-2 text-sm outline-none transition-all appearance-none
            ${error ? 'border-red-500 focus:border-red-500 focus:ring-1 focus:ring-red-500' : 'border-gray-300 focus:border-blue-500 focus:ring-1 focus:ring-blue-500'}
            disabled:bg-gray-50 disabled:text-gray-500
            ${className}
          `} {...props} data-id="element-220">
          <option value="" disabled data-id="element-221">
            Sélectionner...
          </option>
          {options.map(opt => <option key={opt.value} value={opt.value} data-id="element-222">
              {opt.label}
            </option>)}
        </select>
        {error && <p className="mt-1 text-xs text-red-500" data-id="element-223">{error}</p>}
      </div>;
});
Select.displayName = 'Select';